import { useEffect, useState } from 'react'

const useModal = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = ''
      }
    }
    document.body.style.overflow = ''
  }, [visible])

  const show = () => setVisible(true)
  const hide = () => setVisible(false)

  return { visible, show, hide }
}

export default useModal
